import { createSelector } from '@reduxjs/toolkit';

import { formatLengthToArchitecturalString, formatLengthToFeetInchesSixteenthsString } from '@paragon/client-tools';
import { DistanceFormat } from '@paragon/contract-library';

import { RootState } from '..';

export const distanceFormatter = (distanceFormat?: DistanceFormat) => {
  switch (distanceFormat) {
    case 'FeetInchesSixteenths':
      return formatLengthToFeetInchesSixteenthsString;
    case 'Architectural':
    default:
      return formatLengthToArchitecturalString;
  }
};

export const getDistanceFormatterSelector = createSelector(
  (state: RootState) => state.userSettings?.viewOptionSettings.distanceFormat,
  distanceFormatter,
);
